import { AbstractControl, ValidationErrors } from "@angular/forms";

export function InstagramUrlValidator(
    control: AbstractControl
): ValidationErrors | null {
    if (!control.value) {
        return null;
    }

    const instagramRegex = /^(https?:\/\/)?(www\.|m\.)?instagram\.com\/.+$/i;

    const isValid = instagramRegex.test(control.value.trim());

    return isValid ? null : { invalid: true };
}
